// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PredictionForm from './components/PredictionForm';
import RacesList from './components/RacesList';
import Results from './pages/Results';
import DebugPage from './pages/DebugPage';
import AdminResultsPage from './pages/AdminResultsPage';
import Roadmap from './pages/Roadmap';
import Leaderboard from './pages/Leaderboard';
import ResetPassword from './pages/ResetPassword';

// Components
import Header from './components/Header';

// Import the component
import AdminPanel from './pages/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';


// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Predictions from './pages/Predictions';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/predictions" element={<Predictions />} />
              <Route path="/admin" element={<ProtectedRoute element={<AdminPanel />} />} />
              <Route path="/predictions/:raceId" element={<PredictionForm />} />
              <Route path="/races" element={<RacesList />} />
              <Route path="/results" element={<Results />} />
              <Route path="/results/:raceId" element={<Results />} />
              <Route path="/admin/debug" element={<DebugPage />} />
              <Route path="/admin/debug/:raceId" element={<DebugPage />} />
              <Route path="/admin/results-explorer" element={<AdminResultsPage />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;